import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { rhythm, scale } from "../../utils/typography"
import Category from "../../components/category/category"

import style from "./blog-post.module.scss"

import { Disqus, CommentCount } from "gatsby-plugin-disqus"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata.title
  const { previous, next, availableCategories, breadcrumbs } = pageContext
  console.log(previous)
  const disqusConfig = {
    url: `${location.href}`,
    identifier: pageContext.slug,
    title: post.frontmatter.title,
  }

  return (
    <Layout
      availableCategories={availableCategories}
      breadcrumbs={breadcrumbs}
      location={location}
      title={siteTitle}
    >
      <SEO
        lang="uk"
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      <div className={style.container}>
        <article className={style.article}>
          <header>
            <div className={style.article__info}>
              <h1 className={style.article__info_title}>
                {post.frontmatter.title}
              </h1>
              <p className={style.article__info_date}>
                {post.frontmatter.date}
              </p>
              <div className={style.article__info_categories}>
                <Category categories={post.frontmatter.categories} />
              </div>
            </div>
            <div
              style={{
                backgroundImage: `url(${post.frontmatter.image.childImageSharp.fluid.src})`,
              }}
              className={style.article__image}
            ></div>
          </header>
          <section
            className={style.article__body}
            id="postInner"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </article>
        {previous && next ? (
          <nav className={style.nav}>
            {/* <h3 className={style.nav__title}>Популярне</h3> */}
            <div className={style.nav__posts}>
              <Link to={previous.fields.slug} className={style.nav__posts_item}>
                <div
                  className={style.nav__posts_item_image}
                  style={{
                    backgroundImage: `url(${previous.frontmatter.image.childImageSharp.fluid.src})`,
                  }}
                ></div>
                <p className={style.nav__posts_item_title}>
                  {previous.frontmatter.title}
                </p>
                <p className={style.nav__posts_item_text}>
                  {previous.frontmatter.teaser}
                </p>
              </Link>

              <Link to={next.fields.slug} className={style.nav__posts_item}>
                <div
                  className={style.nav__posts_item_image}
                  style={{
                    backgroundImage: `url(${next.frontmatter.image.childImageSharp.fluid.src})`,
                  }}
                ></div>
                <p className={style.nav__posts_item_title}>
                  {next.frontmatter.title}
                </p>
                <p className={style.nav__posts_item_text}>
                  {next.frontmatter.teaser}
                </p>
              </Link>
            </div>
          </nav>
        ) : null}
        <div className={style.disqus}>
          <Disqus config={disqusConfig} />
        </div>
      </div>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "DD.MM.YYYY")
        description
        image {
          childImageSharp {
            fluid {
              src
            }
          }
        }
        categories {
          name
          isDog
          isCat
          value
          priority
          description
        }
      }
    }
  }
`
